export default {
  title: '维保平台',
  // appId:'wxcc3938ac1b469ea7',//测试
  // openId:'oX1AU6RcPf1JoFq9br74MpLquCj8',//测试
  // url:'http://test.weixin.hanslaser.com/',//测试
  appId: 'wxdc6d7ebe6120e8fa',
  url: 'http://weixin.hanslaser.com/',//生产   
}


// WEBPACK FOOTER //
// ./src/const/website.js